// 공통 번역 - 네비게이션, 푸터, 페이지네이션
export default {
  nav: {
    home: '홈',
    about: '소개',
    news: '소식',
    gallery: '갤러리',
    calendar: '일정'
  },
  footer: {
    churchName: '성동중앙교회',
    description: '믿음이 살아있는 따뜻한 공동체입니다. 사랑과 예배, 그리고 하나님과 이웃을 섬기는 일에 함께 성장해 나갑니다.',
    contactUs: '연락처',
    address: '서울특별시 광진구 뚝섬로 468',
    phone: '02-463-1009 / 02-499-1004',
    fax: '02-463-1113',
    email: '01190715326@naver.com',
    serviceTimes: '예배 시간',
    sundayMorning: '주일 낮 예배',
    sundayMorningTime: '오전 11시',
    sundayPraise: '주일 찬양 예배',
    sundayPraiseTime: '오후 3시',
    wednesday: '수요 낮 예배',
    wednesdayTime: '오전 11시',
    fridayPrayer: '금요기도회',
    fridayPrayerTime: '오후 9시',
    copyright: '© 2025 성동중앙교회. All rights reserved.',
    poweredBy: 'Powered by YoungSeok Choi'
  },
  pagination: {
    prev: '이전',
    next: '다음',
    pageOf: '{{total}} 페이지 중 {{current}}'
  },
  language: {
    ko: '한국어',
    en: 'English'
  },
  loading: '불러오는 중...'
};
